import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/user');

class UserApiAgency {

	/* static grid (filter: IUserClientPagedListForAgencyParameters) {
		return client.post('grid', filter);
	} */

	static gridClient (filter: IUserClientPagedListForAgencyParameters) {
		return client.post<IPagedList<IUserClientItemForAgencyModel>>('grid/client', filter);
	}

	static gridTempWorker (filter: IUserTempWorkerPagedListForAgencyParameters) {
		return client.post<IPagedList<IUserTempWorkerItemForAgencyModel>>('grid/tempworker', filter);
	}

	static listTempWorker (filter: IUserTempWorkerListParameters) {
		return client.get<IUserModel[]>('tempworker', { params: filter });
	}

	/* static add (addUserFromFrontModel) {
		return client.post('', addUserFromFrontModel);
	}

	static getDetailed (id) {
		return client.get(id);
	} */

	static getDetailedClient (id: number) {
		return client.get<IUserClientOverPageForAgencyModel>(`${id}/client`);
	}

	static getDetailedTempWorker (id: number) {
		return client.get<IUserModel[]>(`${id}/tempworker`);
	}

	static sendEmailConfirmationTempWorker (id: number) {
		return client.post<void>(`tempworker/sendEmailConfirmation/${id}`);
	}

	static assignableUser (tempWorkerUserId: number) {
		return client.get<IUserAgencyForListModel[]>(`assignableUser`, { params: { tempWorkerUserId } });
	}

	static listForEmail (parameters: IUserAgencyListForEmailPagedListParameters) {
		return client.post<IPagedList<IUserAgencyForEmailModel>>('list/for-email', parameters);
	}
}

export default UserApiAgency;
